var map = {
	"./baby-leggings.svg": 53874,
	"./basic-tote.svg": 68429,
	"./beanies-youth.svg": 40933,
	"./bedroom.svg": 16884,
	"./blanket.svg": 96401,
	"./bottles-and-tumblers.svg": 75948,
	"./boxer-briefs.svg": 50776,
	"./boyshorts.svg": 98811,
	"./cheeky-briefs.svg": 97327,
	"./cotton-fabrics.svg": 61836,
	"./cotton-market-tote.svg": 33397,
	"./day-tote.svg": 41973,
	"./desk-mat.svg": 91306,
	"./drawstring-bag.svg": 60652,
	"./dresses.svg": 98257,
	"./face-coverings.svg": 16390,
	"./headwear.svg": 54331,
	"./hemp-fabrics.svg": 65047,
	"./hoodies.svg": 28367,
	"./kitchen.svg": 43448,
	"./large-basic-cotton-tote.svg": 75519,
	"./large-basic-tote.svg": 59733,
	"./large-notebooks.svg": 37500,
	"./leggings-and-pants.svg": 50901,
	"./living-room.svg": 10209,
	"./long-sleeve-shirts.svg": 31859,
	"./makeup-bags.svg": 40083,
	"./market-totes.svg": 54438,
	"./office.svg": 99200,
	"./origami-tote.svg": 6241,
	"./performance-polyester-fabrics.svg": 29995,
	"./permanent-sticker.svg": 7912,
	"./pillow-cases.svg": 42139,
	"./robes.svg": 14633,
	"./scarves.svg": 86499,
	"./scoop-bralette.svg": 17772,
	"./seasonal.svg": 17480,
	"./shorts.svg": 52229,
	"./silk-fabrics.svg": 61046,
	"./skirts.svg": 12528,
	"./small-notebooks.svg": 44256,
	"./spiral-notebooks.svg": 9258,
	"./stainless-steel-tumbler.svg": 54628,
	"./stationery-cards.svg": 8860,
	"./t-shirts.svg": 22098,
	"./tank-tops.svg": 88973,
	"./tea-towels.svg": 37319,
	"./unisex-joggers.svg": 50112,
	"./urban-tote.svg": 30047,
	"./vegan-leather-backpack.svg": 77058,
	"./vegan-leather-crossbody-purse.svg": 76498,
	"./vegan-leather-makeup-bag.svg": 1744,
	"./vegan-leather-tote-bag.svg": 67827,
	"./wall-art.svg": 37032,
	"./woven-polyester-fabrics.svg": 40828,
	"./yoga-shorts.svg": 42088,
	"./youth-leggings.svg": 2714,
	"./zipper-pouches.svg": 66240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41574;